export function disclosures() {
    (function() {
        /**
         * Auto-number disclosure items
         */
        $('.disclosures').each(function() {
            $(this).find('.disclosure-item').each(function(index) {
                const number = $('<sup/>', {
                    class: 'disclosure-number',
                    text: index + 1
                });
                const firstParagraph = $(this).children('p').first();
                if (firstParagraph.length) {
                    firstParagraph.prepend(number, ' ');
                } else {
                    $(this).prepend(number, ' ');
                }
            });
        });
    })();
}
